(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('FooterController', FooterController);

	FooterController.$inject = [ '$state' ];

	function FooterController($state) {
		var vm = this;
	}
})();
